var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-x-widget',{ref:"widget",attrs:{"preview-mode":false,"loading":_vm.loading,"widget-data":_vm.widgetData,"domain-data":_vm.domainData,"field-types":_vm.fieldTypes,"social-auth":true,"user-data":_vm.userData},on:{"update:loading":function($event){_vm.loading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }